import { render } from "./ChartScatter.vue?vue&type=template&id=2f25b36e"
import script from "./ChartScatter.vue?vue&type=script&lang=js"
export * from "./ChartScatter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/ChartScatter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f25b36e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f25b36e', __exports__)) {
    api.reload('2f25b36e', __exports__)
  }
  
  module.hot.accept("./ChartScatter.vue?vue&type=template&id=2f25b36e", () => {
    api.rerender('2f25b36e', render)
  })

}


export default __exports__